import type { QueryKey } from "@tanstack/react-query";
import { appendTzToQueryKey } from "src/queries/timeWindowQueryKey";
import { useGlobalLocalContext } from "src/storage/localStorage";
import {
  type FetchParams,
  getCleanBodyParams,
  getStringifiedBodyParams,
} from "src/utils/dfetch.ts";
import { queryClient } from "@utils/query-client.ts";
import { queryFnWrapper } from "./queryFnWrapper";

export const fetchOutsideReact = async <T, Select = T>(
  props: FetchParams & { queryKey?: QueryKey }
) => {
  const { body, url, queryKey: queryKeyProp } = props;

  const paramsKey = getStringifiedBodyParams(body);
  const queryKey =
    queryKeyProp ||
    appendTzToQueryKey([url, paramsKey], body, useGlobalLocalContext.getState().tz);

  const queryFn = async (): Promise<T> => {
    const cleanBody = body ? getCleanBodyParams(body) : undefined;

    const result = await queryFnWrapper<T>({
      url,
      body: cleanBody,
    });
    return result as unknown as T;
  };

  return await queryClient.fetchQuery<T, Error, Select, QueryKey>({
    queryKey,
    queryFn,
  });
};
